import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Protected({ children }: { children: React.ReactNode }) {
  const [ok, setOk] = useState<boolean | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    let unsub: (() => void) | undefined

    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) {
        navigate('/signin', { replace: true })
      } else {
        setOk(true)
      }
    })

    const sub = supabase.auth.onAuthStateChange((_e, session) => {
      if (!session) navigate('/signin', { replace: true })
      else setOk(true)
    })
    unsub = () => sub.data.subscription.unsubscribe()

    return () => { if (unsub) unsub() }
  }, [navigate])

  if (!ok) return <div style={{ padding: 24 }}>Loading…</div>
  return <>{children}</>
}
